import { useState } from 'react';
import { useOnboardingStore } from '../../stores/useOnboardingStore';
import { BUSINESS_TYPES } from '../../models/onboarding.constants';
import styles from './BusinessTypeModal.module.css';

const BusinessTypeModal = () => {
  const showBusinessTypeModal = useOnboardingStore((s) => s.showBusinessTypeModal);
  const setBusinessType = useOnboardingStore((s) => s.setBusinessType);
  const [selected, setSelected] = useState<number>(0);

  if (!showBusinessTypeModal) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>¿Qué tipo de negocio tienes?</h2>
        <p className={styles.subtitle}>
          Esto nos ayuda a personalizar tu experiencia
        </p>

        <div className={styles.options}>
          {BUSINESS_TYPES.map((type) => (
            <button
              key={type.id}
              className={`${styles.option} ${selected === type.id ? styles.optionSelected : ''}`}
              onClick={() => setSelected(type.id)}
            >
              <span className={styles.optionIcon}>{type.icon}</span>
              <span className={styles.optionLabel}>{type.label}</span>
            </button>
          ))}
        </div>

        <button
          className={styles.btnContinue}
          disabled={selected === 0}
          onClick={() => setBusinessType(selected)}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default BusinessTypeModal;
